<template lang="pug">
.v-catalog-item.catalog-item(v-if="catalog")
	v-loader(:loading="loading")
	.catalog-item__container.container
		template(v-if="!catalog")
			.catalog__placeholder
		template(v-if="catalog && catalog.item")
			.catalog-item__title-wrapper
				.catalog-item__title-container
					v-svg-icon.catalog-item__title-icon(icon="back-arrow"
							@click="goBack")
					.catalog-item__title(v-if="catalog.item.name") {{catalog.item.name}}
				v-favorite-action.catalog-item__favorite-action(:id="catalog.item.id" :name="catalog.item.name")
			.catalog-item__wrap
				.catalog-item__left-section
					.catalog-item__left-main
						.catalog-item__aside
							.catalog-item__visual-wrap
								.catalog-item__visual
									.catalog-item__status
									template(v-if="catalog.item.images")
										v-image-slider(:data-source="catalog.item.images")
									template(v-else-if="!catalog.item.images")
										img.catalog-item__no-image(:src="noImageSrc" alt="")
						.catalog-item__main
							.catalog-item__filter.flc(v-if="catalog.filters && catalog.filters.length > 0")
								.catalog-item__filter-item(v-for="(filter, filterIndex) in catalog.filters" :key="filterIndex")
									v-field(v-model="filter.value" :field="{...filter, label: filter.title}" @update:model-value="filterChanged(filter)")
							v-sidebar(v-if="isSm" :data-source="catalog.item")
							template(v-if="!isSm")
								v-params(v-if="catalog.item.params" :data-source="catalog.item.params")
					.catalog-item__left-additional
						v-selection(v-if="catalog.selection" :data-source="catalog.selection")
						v-peculiarities(v-if="catalog.peculiarities" :data-source="catalog.peculiarities")
						template(v-if="isSm")
							v-params(v-if="catalog.item.params" :data-source="catalog.item.params")
						template(v-if="isLoaded")
							v-reviews-big(v-if="catalog.reviewsBig" :data-source="catalog.reviewsBig")
							template(v-if="$slots['reviews']")
								slot(name="reviews")
							template(v-if="$slots['viewer360']")
								slot(name="viewer360")
							v-panoramic(v-if="catalog.panoramic" :data-source="catalog.panoramic")
						v-description(v-if="catalog.description" :data-source="catalog.description")
						template(v-if="$slots['questions']")
							slot(name="questions")
						v-cars-btns(v-if="catalog.carsBtns" :data-source="catalog.carsBtns")
				v-sidebar.catalog-item__sidebar(v-if="!isSm" :data-source="catalog.item")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import loadMixin from './mixins/v-load-mixin.vue';
import controller from '../scripts/controller/controller.js';
import {mapGetters} from "vuex";

export default {
	mixins: [
		sourceMixin,
		isMobMixin,
		loadMixin
	],

	data() {
		return {
			catalog: null,
			isHovered: {},
			isActive: false,
			descriptionCount: 10,
			state: {
				filter: null
			},
			changedFilters: null,
			noImageSrc: '/local/assets/images/no-photo.svg',
		};
	},

	created() {
		controller.events.on('change-color', field => {
			this.filterChanged(field)
		})
	},

	computed: {
		...mapGetters({
			country: 'delivery/country',
			currency: 'delivery/currency'
		}),
	},

	watch: {
		country() {
			this.requestDataLoad();
		},

		currency() {
			this.requestDataLoad();
		}
	},

	methods: {
		dataSet(data) {
			this.catalog = data;
		},

		goBack() {
			window.history.back();
		},

		createFilterValue(field) {
			if (!this.catalog || !this.catalog.filters) {
				return null;
			}
			let result = {};
			this.catalog.filters.forEach(filter => {
				result[filter.name] = filter.value;
			});
			result[field.name] = field.value
			result['filterChanged'] = field.id;
			return result;
		},

		filterChanged(field) {
			this.requestDataLoad(field);
		},

		requestDataLoad(field) {
			if (this.catalog && this.catalog.remote) {
				this.dataLoad({
					url: this.catalog.remote,
					delay: true,
					data: {
						filter: field ? this.createFilterValue(field) : null,
						country: this.country.value,
						currency: this.currency.value
					}
				});
			}
		}
	}
};
</script>